<div class="header">
  <button class="back-button" (click)="goToDashboard()"><mat-icon class="back-icon">chevron_left</mat-icon></button>
  <h1>{{ lesson.title }}</h1>
</div>
<div class="lesson-container">
  <div class="content">
    <h2>Lektion erstellen ({{currentPageIndex + 1}}/{{lessonPages.length + 1}})</h2>
    @if (currentPageIndex === 0) {
      <h3>Bezeichnung der Lektion</h3>
      <form class="lesson-form" (ngSubmit)="saveLesson()">
        <div class="content-box">
          <input matInput [(ngModel)]="lessonTitle" name="lessonTitle"
            placeholder="Geben Sie hier einen neuen Titel ein" class="content-input" type="text" required />
        </div>
        <h3>Kachelbild</h3>
        <mat-radio-group [(ngModel)]="selectedImageId" name="selectedImageId" class="image-grid">
          @for (image of lessonPictures; track image) {
            <div class="image-option">
              <img [src]="image.imageData" [alt]="image.path" class="image-preview" />
              <mat-radio-button [value]="image.id" class="radio-button"></mat-radio-button>
            </div>
          }
        </mat-radio-group>
        <div class="button-container">
          <button mat-raised-button color="primary" type="submit" [disabled]="!metaDataHasChanges()">Speichern</button>
          <button mat-raised-button color="accent" (click)="deleteLesson()" type="button">Lektion
          löschen</button>
          <mat-slide-toggle class="published-toggle" [checked]="lesson.published" (change)="togglePublicationStatus()">
            {{ lesson.published ? 'Veröffentlicht' : 'Nicht veröffentlicht' }}
          </mat-slide-toggle>
        </div>
      </form>
    }

    @if (currentPageIndex === 1) {
      <h3>{{lessonPages[0].title}}</h3>
      <h4>Informationen</h4>
      @for (item of lessonPageItems | filterTextType; track item) {
        <div class="text-item">
          <div class="video-header">
            <div class="content-box">
              <input matInput [(ngModel)]="item.title" name="text_item_title" placeholder="Titel"
                class="content-input" type="text" required />
            </div>
            <div class="actions">
              <button mat-icon-button color="primary" class="save-button" (click)="saveItem(item)">
                <mat-icon>save</mat-icon>
              </button>
              <button mat-icon-button color="warn" class="delete-button" (click)="deleteItem(item.id)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
          <textarea matInput [(ngModel)]="item.content" [name]="'info_text'"
          placeholder="Geben Sie hier weitere Informationen ein." class="content-input"></textarea>
        </div>
      }
      @if ((lessonPageItems | filterTextType).length == 0) {
        <div class="add-text" (click)="addText()">
          <span>Text hinzufügen</span>
          <mat-icon>add</mat-icon>
        </div>
      }
      <h4>Material</h4>
      @if (lessonPageItems && lessonPageItems.length > 0) {
        <div class="existing-material-container">
          @for (item of lessonPageItems | filterVideoType; track item) {
            <div class="video-item">
              <div class="video-header">
                <div class="content-box">
                  <input matInput [(ngModel)]="item.title" name="text_item_title" placeholder="Titel"
                    class="content-input" type="text" required />
                </div>
                <div class="actions">
                  <button mat-icon-button color="primary" class="save-button" (click)="saveItem(item)">
                    <mat-icon>save</mat-icon>
                  </button>
                  <button mat-icon-button color="warn" class="delete-button" (click)="deleteItem(item.id)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
              @if (item.videoData) {
                <video controls [src]="item.videoData"></video>
              }
            </div>
          }
        </div>
      }
      <div class="add-material" (click)="addMaterial()">
        <span>Material hinzufügen</span>
        <mat-icon>add</mat-icon>
      </div>
    }

    @if (currentPageIndex === 2) {
      <h3>{{lessonPages[1].title}}</h3>
      @if (lessonPageItems && lessonPageItems.length > 0) {
        <div class="existing-material-container">
          @for (item of lessonPageItems | filterVideoType; track item) {
            <div class="video-item">
              <div class="video-header">
                <div class="content-box">
                  <input matInput [(ngModel)]="item.title" name="text_item_title" placeholder="Titel"
                    class="content-input" type="text" required />
                </div>
                <div class="actions">
                  <button mat-icon-button color="primary" class="save-button" (click)="saveItem(item)">
                    <mat-icon>save</mat-icon>
                  </button>
                  <button mat-icon-button color="warn" class="delete-button" (click)="deleteItem(item.id)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
              @if (item.videoData) {
                <video controls [src]="item.videoData"></video>
              }
            </div>
          }
        </div>
      }
      <div class="add-material" (click)="addMaterial()">
        <span>Material hinzufügen</span>
        <mat-icon>add</mat-icon>
      </div>
    }

    @if (currentPageIndex === 3) {
      <h3>{{lessonPages[2].title}}</h3>
      <h4>Informationen</h4>
      @for (item of lessonPageItems | filterTextType; track item) {
        <div class="text-item">
          <div class="video-header">
            <div class="content-box">
              <input matInput [(ngModel)]="item.title" name="text_item_title" placeholder="Titel"
                class="content-input" type="text" required />
            </div>
            <div class="actions">
              <button mat-icon-button color="primary" class="save-button" (click)="saveItem(item)">
                <mat-icon>save</mat-icon>
              </button>
              <button mat-icon-button color="warn" class="delete-button" (click)="deleteItem(item.id)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
          <textarea matInput [(ngModel)]="item.content" [name]="'info_text'"
          placeholder="Geben Sie hier weitere Informationen ein." class="content-input"></textarea>
        </div>
      }
      @if ((lessonPageItems | filterTextType).length == 0) {
        <div class="add-text" (click)="addText()">
          <span>Text hinzufügen</span>
          <mat-icon>add</mat-icon>
        </div>
      }
      <h4>Material</h4>
      @if (lessonPageItems && lessonPageItems.length > 0) {
        <div class="existing-material-container">
          @for (item of lessonPageItems | filterVideoType; track item) {
            <div class="video-item">
              <div class="video-header">
                <div class="content-box">
                  <input matInput [(ngModel)]="item.title" name="text_item_title" placeholder="Titel"
                    class="content-input" type="text" required />
                </div>
                <div class="actions">
                  <button mat-icon-button color="primary" class="save-button" (click)="saveItem(item)">
                    <mat-icon>save</mat-icon>
                  </button>
                  <button mat-icon-button color="warn" class="delete-button" (click)="deleteItem(item.id)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
              @if (item.videoData) {
                <video controls [src]="item.videoData"></video>
              }
            </div>
          }
        </div>
      }
      <div class="add-material" (click)="addMaterial()">
        <span>Material hinzufügen</span>
        <mat-icon>add</mat-icon>
      </div>
    }

    @if (currentPageIndex === 4) {
      <h3>{{lessonPages[3].title}}</h3>
      <form #quizForm="ngForm" class="quiz-form" (ngSubmit)="saveQuiz()" novalidate>
        <div class="quiz-question-container">
          <div class="video-header">
            <h4>Quizfrage*</h4>
            @if (existingQuizId) {
              <button mat-icon-button color="warn" class="delete-button" (click)="deleteItem(existingQuizId)"
                type="button">
                <mat-icon>delete</mat-icon>
              </button>
            }
          </div>
          <input matInput [(ngModel)]="quizQuestion" name="quizQuestion"
            placeholder="Geben Sie hier eine Frage ein." class="content-input" type="text" required />
        </div>
        <div class="quiz-answer-container">
          @for (answer of quizAnswers; track answer; let i = $index) {
            <div class="answer-container">
              <div class="video-header">
                <h4>Option {{ i + 1 }}@if (i < 3) {
                  <span>*</span>
                }</h4>
                @if (i >= 3) {
                  <button mat-icon-button color="warn" class="delete-button" (click)="deleteAnswer(i)"
                    type="button">
                    <mat-icon>delete</mat-icon>
                  </button>
                }
              </div>
              <div class="quiz-answer-text-area-container">
                <textarea matInput [(ngModel)]="answer.answer_text" [name]="'answer_' + i"
                placeholder="Antwort..." class="content-input" required></textarea>
                <textarea matInput [(ngModel)]="answer.response_text" [name]="'response_' + i"
                placeholder="Auflösung..." class="content-input" required></textarea>
              </div>
            </div>
          }
          @if (quizAnswers.length < 5) {
            <div class="add-quiz" (click)="addAnswer()">
              <span>Antwort hinzufügen</span>
              <mat-icon>add</mat-icon>
            </div>
          }
        </div>
        <div class="button-container">
          <button mat-raised-button color="primary" type="submit"
          [disabled]="quizForm.invalid || quizAnswers.length < 3">Speichern</button>
        </div>
      </form>
    }

    @if (currentPageIndex === 5) {
      <h3>{{lessonPages[4].title}}</h3>
      <h4>Fazit und weitere Informationen</h4>
      @for (item of lessonPageItems | filterTextType; track item) {
        <div class="text-item">
          <div class="video-header">
            <div class="content-box">
              <input matInput [(ngModel)]="item.title" name="text_item_title" placeholder="Titel"
                class="content-input" type="text" required />
            </div>
            <div class="actions">
              <button mat-icon-button color="primary" class="save-button" (click)="saveItem(item)">
                <mat-icon>save</mat-icon>
              </button>
              <button mat-icon-button color="warn" class="delete-button" (click)="deleteItem(item.id)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
          <textarea matInput [(ngModel)]="lessonPageItems[0].content" [name]="'info_text'"
            placeholder="Geben Sie hier weitere Informationen ein." class="content-input full-page-text-area"
          required></textarea>
        </div>
      }
      @if ((lessonPageItems | filterTextType).length == 0) {
        <div class="add-text" (click)="addText()">
          <span>Text hinzufügen</span>
          <mat-icon>add</mat-icon>
        </div>
      }
    }

    @if (currentPageIndex === 6) {
      <h3>{{lessonPages[5].title}}</h3>
      <h4>Informationen</h4>
      @for (item of lessonPageItems | filterTextType; track item) {
        <div class="text-item">
          <div class="video-header">
            <div class="content-box">
              <input matInput [(ngModel)]="item.title" name="text_item_title" placeholder="Titel"
                class="content-input" type="text" required />
            </div>
            <div class="actions">
              <button mat-icon-button color="primary" class="save-button" (click)="saveItem(item)">
                <mat-icon>save</mat-icon>
              </button>
              <button mat-icon-button color="warn" class="delete-button" (click)="deleteItem(item.id)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
          <textarea matInput [(ngModel)]="item.content" [name]="'info_text'"
          placeholder="Geben Sie hier weitere Informationen ein." class="content-input"></textarea>
        </div>
      }
      @if ((lessonPageItems | filterTextType).length == 0) {
        <div class="add-text" (click)="addText()">
          <span>Text hinzufügen</span>
          <mat-icon>add</mat-icon>
        </div>
      }
      <h4>Material</h4>
      @if (lessonPageItems && lessonPageItems.length > 0) {
        <div class="existing-material-container">
          @for (item of lessonPageItems | filterVideoType; track item) {
            <div class="video-item">
              <div class="video-header">
                <div class="content-box">
                  <input matInput [(ngModel)]="item.title" name="text_item_title" placeholder="Titel"
                    class="content-input" type="text" required />
                </div>
                <div class="actions">
                  <button mat-icon-button color="primary" class="save-button" (click)="saveItem(item)">
                    <mat-icon>save</mat-icon>
                  </button>
                  <button mat-icon-button color="warn" class="delete-button" (click)="deleteItem(item.id)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
              @if (item.videoData) {
                <video controls [src]="item.videoData"></video>
              }
            </div>
          }
        </div>
      }
      <div class="add-material" (click)="addMaterial()">
        <span>Material hinzufügen</span>
        <mat-icon>add</mat-icon>
      </div>
    }
  </div>
  <div class="bear-picture-container">
    <img [src]="picturePath" alt="Picture of a Bear" class="bear-picture">
  </div>
  <div class="bottom-navigation">
    <button (click)="goToPage(currentPageIndex - 1)" [disabled]="currentPageIndex === 0">Zurück</button>
    @if (!(currentPageIndex === lessonPages.length)) {
      <button (click)="goToPage(currentPageIndex + 1)" [disabled]="currentPageIndex === lessonPages.length"
      >Weiter</button>
    }
    @if (currentPageIndex === lessonPages.length) {
      <button (click)="finishLesson()">Veröffentlichen</button>
    }
  </div>
</div>